import * as ReactUse from 'react-use';

const { useCounter } = ReactUse;

export function useCountDown(v: number, opts?: { delay?: number, done?: () => void }) {
  const [value, { dec, get, reset }] = useCounter(v);

  let timer: any;

  function start() {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setInterval(() => {
      if (get() <= 0) {
        clearInterval(timer);
        opts?.done?.();
        return;
      }
      dec();
    }, opts?.delay || 1 * 1000);
  }

  function resetCountDown() {
    if (timer) {
      clearInterval(timer);
    }
    reset();
  }
  return [value, { reset: resetCountDown, get, start }] as const;
}
